<table
    mat-table
       [dataSource]="dataSource" [multiTemplateDataRows]="true"
       class="table-mobile">
  <ng-container matColumnDef="{{columns[0]}}" *ngFor="let columns of columnEntries">
    <ng-container>
      <th mat-header-cell *matHeaderCellDef [attr.colspan]="columnsMobileNames.length">
        <ng-container *ngIf="columns[0]==='1' && showInformation">
          <ng-content select="[mobileFilters]"></ng-content>
        </ng-container>
        <ng-content select="[mobileHeader]"></ng-content>
      </th>
    </ng-container>
    <td mat-cell *matCellDef="let element" class="table-data">
      <div>
        <div class="flex" fxLayout="column">
          <div *ngFor="let column of columns[1]"
               class="columns"
               [ngStyle]="getStyles(column, element)">
            <ng-container *ngIf="column.iconBefore">
              <ng-container *ngTemplateOutlet="iconBefore">
              </ng-container>
            </ng-container>
            <ng-container *ngIf="column.prefix">{{ column.prefix }}</ng-container>

            <ng-container *ngIf="column.isHtml; else tdValue">
              <div [innerHTML]=" element[column.name]| safeHtml"></div>
            </ng-container>
            <ng-template #tdValue>
              <ng-container *ngIf="column.pipe ; else valueWithoutPipe">
                {{ column.pipe.transform(element[column.name], column.pipeParam) }}
              </ng-container>
              <ng-template #valueWithoutPipe>

                <ng-container *ngIf="column.name==='billerName'; else notBillerName">
                  <div *ngIf="isApple() && column.name==='billerName' && element.firstInCurrentMonth"
                       class="show-month">
                    <span>
                      Bieżący miesiąc
                    </span>
                  </div>
                  <div [style]="{overflow: 'hidden', 'max-width': '200px', width: '200px' }">
                    {{ element[column.name] }}
                  </div>
                </ng-container>
                <ng-template #notBillerName>
                  {{ element[column.name] }}
                </ng-template>

              </ng-template>





            </ng-template>
            <ng-container *ngIf="column.sufix">{{ column.sufix }}</ng-container>
            <ng-container *ngIf="column.iconAfter">
              <ng-container *ngTemplateOutlet="iconAfter">
              </ng-container>
            </ng-container>
            <ng-template #iconBefore>
              <app-icon [name]="column.iconBefore" width="8" height="8"
                        [ngStyle]="column.iconBeforeStyle(element)"></app-icon>
            </ng-template>
            <ng-template #iconAfter>
              <app-icon [name]="column.iconAfter" width="8" height="8"
                        [ngStyle]="column.iconAfterStyle(element)"></app-icon>
            </ng-template>
          </div>
        </div>
      </div>
    </td>
  </ng-container>


  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element"
        [attr.colspan]="columnsMobileNames.length"
        [ngStyle]="{'background-color': isEven(element) ? 'white' : '#F6F6F6'}">

      <div style="display: flex; height: 74px" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
        <div class="element-detail text-sm">
          <div class="element-detail-header">
            <div>
              <div class="text-xs text-grey">Data umowy</div>
              <div class="accent-color">{{ element.contractDate | date: 'dd.MM.yyyy' + ' r.' }}</div>
            </div>
            <div>
              <div class="text-xs text-grey">Kwota umowy</div>
              <div class="accent-color">{{ element.amountNet + ' zł' }}</div>
            </div>
            <div>
              <div class="text-xs text-grey text-right">Nr umowy</div>
              <div class="accent-color">{{ element.contractNumber }}</div>
            </div>
          </div>

          <div class="element-detail-separator"></div>

          <app-expanded-detail
            *ngIf="expandedComponent"
            [value]="element"></app-expanded-detail>
        </div>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="checkboxSelect" style="width: 3rem;">
    <th mat-header-cell *matHeaderCellDef style="width: 3rem; padding-right: 1rem">
      <mat-checkbox
        *ngIf="!multiselectDisabled"
        [disabled]="isSelectAllDisabled"
        (change)="$event ? onToggleAll() : null"
        [checked]="hasSelectedValue && isAllSelected()"
        [indeterminate]="(hasSelectedAnotherValue || hasSelectedValue) && !isAllSelected()"
        [aria-label]="checkboxLabel()">
        <span class="cdk-visually-hidden">Zaznacz/Odznacz</span>
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let element" (click)="checkboxMobileClick($event, element)"
        style="padding-right: 1rem"
        [ngStyle]="{'cursor': !isCheckboxSelectionDisabled(element) ? 'pointer' : null, 'width': '3rem'}">
      <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? toggleElement(element) : null"
                    [disabled]="isCheckboxSelectionDisabled(element)"
                    [checked]="isSelected(element)"
                    [aria-label]="checkboxLabel(element)">
        <span class="cdk-visually-hidden">Zaznacz/Odznacz</span>
      </mat-checkbox>
    </td>
  </ng-container>
  <ng-container matColumnDef="expanded">
    <th mat-header-cell *matHeaderCellDef>
      <span class="cdk-visually-hidden">Menu</span>
    </th>
    <td mat-cell *matCellDef="let element">
      <div>
        <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element);
          $event.stopPropagation()">
          <app-icon *ngIf="expandedElement !== element" name="keyboard_arrow_down"></app-icon>
          <app-icon *ngIf="expandedElement === element" name="keyboard_arrow_up"></app-icon>
        </button>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="headerColumnNames"></tr>


  <tr mat-row *matRowDef="let element; columns: columnsMobileNames;"
      [ngClass]="{
        'even-row':  isEven(element),
         'odd-row': !isEven(element),
        'show-data-name': !isApple() && element.firstInCurrentMonth
        } "
      [attr.data-name]="element.firstInCurrentMonth ? 'Bieżący miesiąc' : null"
      (click)="rowOnclick.next(element)"
      [ngStyle]="rowStyle ? rowStyle(element) : {}">
  </tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
</table>
